import { render, staticRenderFns } from "./customImgView.vue?vue&type=template&id=58efe07a&scoped=true"
import script from "./customImgView.vue?vue&type=script&lang=js"
export * from "./customImgView.vue?vue&type=script&lang=js"
import style0 from "./customImgView.vue?vue&type=style&index=0&id=58efe07a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58efe07a",
  null
  
)

export default component.exports